import styled from "styled-components";
import { fontFamilies, fontSizes } from "components/shared/tokens/typography";
import red from "components/shared/tokens/color/red";

export const WarningBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(20, 25, 30, 0.78);
  backdrop-filter: blur(3px);
  font-family: ${fontFamilies.regular};
`;

export const Dialog = styled.div`
  width: 100%;
  max-width: 294px;
  border-radius: 24px;
  background: #ffffff;
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 24px 22px;
`;

export const WarningIcon = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff0e6;

  span {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 1px;
    border-radius: 50%;
    background: #d9501a;
    color: #ffffff;
    font-family: ${fontFamilies.bold};
    font-size: ${fontSizes.z600};
    line-height: 1;
  }
`;

export const DialogTitle = styled.h2`
  max-width: 245px;
  margin: 19px 0 0;
  color: #1c1c1c;
  font-family: ${fontFamilies.semiBold};
  font-size: ${fontSizes.z400};
  line-height: 1.35;
  text-align: center;
`;

export const DialogAction = styled.button`
  min-height: 42px;
  margin-top: 18px;
  padding: 8px 24px;
  border: 0;
  background: transparent;
  color: ${red.z500};
  font-family: ${fontFamilies.regular};
  font-size: ${fontSizes.z300};
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
`;
